<div class="title-box text-center">
      <h6 class="title text-white">{{title}}</h6>
      <h2 class="text-white">{{subtitle}}</h2>
</div>
